import React from 'react';
import styled from 'styled-components';
import { getFilterValueForColor } from '@nile/components';

const BackgroundIcon = styled.div`
  background-image: ${(props) => props.url};
  background-size: ${(props) => props.size || '100%'};
  background-repeat: no-repeat;
  background-position: ${(props) => props.position || 'intial'};
  height: ${(props) => props.height || '20px'};
  width: ${(props) => props.width || '20px'};
  opacity: ${(props) => props.opacity || '1'};
  filter: ${(props) => {
    if (props.color) {
      const filter = getFilterValueForColor(props.color);
      return filter;
    }
    return '';
  }};
`;
const Emoji = (props) => (
  <span className="emoji" role="img">
    {props.symbol}
  </span>
);

export { BackgroundIcon, Emoji };
